





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { MerchantModel } from '@/models/MerchantModel';
import { LocationStatus } from '@/enums';
import { CSSPartialDeclaration } from '@/types';
import { getCoverPhotoUrl } from '@/utils/common-utils';

@Component
export default class MerchantListItem extends Vue {
  @Prop() private merchant!: MerchantModel;

  @Prop() private distance!: number | null;

  get fulfillment() {
    return this.merchant.curbsidePickup ? 'Curbside Available' : null;
  }

  get isOpen(): boolean {
    return this.merchant.state === LocationStatus.Open;
  }

  get isBusy(): boolean {
    return this.merchant.state === LocationStatus.Busy;
  }

  get locationStatus(): string {
    switch (this.merchant.state) {
      case LocationStatus.Open: return 'Open';
      case LocationStatus.Busy: return 'Busy';
      case LocationStatus.Closed: return 'Closed';
      default: return '';
    }
  }

  get addressList(): [string, string] {
    const { fullAddress } = this.merchant;
    const index = fullAddress.indexOf(',');
    return [
      fullAddress.slice(0, index),
      fullAddress.slice(index + 1),
    ];
  }

  get backgroundStyle(): CSSPartialDeclaration {
    if (this.merchant.coverPhotoUrls[0]) {
      return {
        backgroundImage: `url(${getCoverPhotoUrl(this.merchant.coverPhotoUrls)})`,
      };
    }

    return {};
  }
}
